import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import css_248z from './single-component-container.scss.js';

class SingleComponentContainer extends s {
    render() {
        return x `<div class="single-component-container"><slot></slot></div>`;
    }
}
SingleComponentContainer.styles = css_248z;
customElements.define('single-component-container', SingleComponentContainer);

export { SingleComponentContainer };
